var _style, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileFrameBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 440 860",
    style: {
      enableBackground: "new 0 0 440 860"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n\t.st1{fill:#616161;}\n\t.st2{fill:#333333;}\n\t.st3{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.6,157.4v97.4c0,0.6-0.7,1.2-1.5,1.2h-2.8v-99.8h2.8C432.9,156.2,433.6,156.8,433.6,157.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.3,256v527.1c0,37.7-30.7,68.4-68.4,68.4H80.1c-37.7,0-68.4-30.7-68.4-68.4V300v-61.5v-20.9v-61.5v-31.5 V94.2V75.4C11.7,37.7,42.4,7,80.1,7h280.7c37.7,0,68.4,30.7,68.4,68.4v80.8V256z M423,783.1V75.4c0-34.3-27.9-62.2-62.2-62.2H80.1 C45.8,13.2,18,41.1,18,75.4v707.6c0,34.3,27.8,62.2,62.2,62.2h280.7C395.2,845.2,423,817.4,423,783.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423,75.4v707.6c0,34.3-27.8,62.2-62.2,62.2H80.1c-34.3,0-62.2-27.8-62.2-62.2V75.4c0-34.3,27.8-62.2,62.2-62.2 h280.7C395.2,13.2,423,41.1,423,75.4z M415.5,781.5V76.3c0-30.6-24.8-55.3-55.3-55.3H80.8c-30.5,0-55.3,24.8-55.3,55.3v705.2 c0,30.6,24.8,55.3,55.3,55.3h279.4C390.7,836.8,415.5,812,415.5,781.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,238.6V300H8.9c-0.8,0-1.5-0.5-1.5-1.2v-59.1c0-0.7,0.7-1.2,1.5-1.2H11.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,156.2v61.5H8.9c-0.8,0-1.5-0.5-1.5-1.2v-59.1c0-0.6,0.7-1.2,1.5-1.2H11.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,94.2v30.5H8.9c-0.8,0-1.5-0.5-1.5-1.2V95.3c0-0.7,0.7-1.2,1.5-1.2H11.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 11.7,
    y1: 156.2,
    x2: 11.7,
    y2: 124.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 11.7,
    y1: 238.6,
    x2: 11.7,
    y2: 217.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M429.3,256v527.1c0,37.7-30.7,68.4-68.4,68.4H80.1c-37.7,0-68.4-30.7-68.4-68.4V300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFrameBlack);
export default __webpack_public_path__ + "static/media/mobile-frame-black.40403426c99bfd8edb28680c8f0d350d.svg";
export { ForwardRef as ReactComponent };